import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import React from 'react';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '../../../../core/Button';
import Form from '../../../../form';
import Modal from '../../../../modal';
import Utils from '../../../../utils';
import DataItem from '../../../../data/Item/DataItem';
import FormLabel from '@material-ui/core/FormLabel';
var emailTypes = [{
  value: 'SMTP',
  label: 'Use an Email Server'
}, {
  value: 'AWS',
  label: 'Use Amazon',
  name: 'EmailAWS'
}];
var awsTypes = [{
  value: 'Domain',
  label: 'Domain'
}, {
  value: 'Email',
  label: 'Email'
}];

var Queue = function Queue(_ref) {
  var queue = _ref.queue,
      history = _ref.history;

  var _React$useState = React.useState({
    status: {
      error: null,
      success: null
    }
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      emailConnection = _React$useState2[0],
      setEmailConnection = _React$useState2[1];

  var verifyAWSConnection = function verifyAWSConnection(queue) {
    return Utils.request({
      url: '/backend/EmailQueueConnection/getawsdomaintoken?queuename=' + queue,
      method: 'GET',
      data: {}
    }).then(function (response) {
      Modal.open({
        type: Modal.TYPES.VERIFY_EMAIL_SETTINGS,
        props: {
          AWSEmail: queue.AWSEmail,
          AWSDomain: queue.AWSDomain,
          Token: response.ValidationToken,
          AWSType: queue.AWSType
        }
      });
      setConnectionTestResult({
        failed: false
      });
    }).catch(function (err) {});
  };

  var resendAWSEmail = function resendAWSEmail() {
    return Utils.request({
      url: '/backend/EmailQueueConnection/getawsdomaintoken?queuename=' + queue,
      method: 'GET',
      data: {}
    }).catch(function (err) {});
  };

  function renderSMTPEMailConnection() {
    return React.createElement(React.Fragment, null, React.createElement(Form.Fields.Email, {
      placeholder: "notification@email.com",
      required: true,
      name: "SMTPFrom",
      label: "From",
      autoComplete: true
    }), React.createElement(Form.Fields.Domain, {
      placeholder: "smtp.email.com",
      required: true,
      name: "SMTPHost",
      label: "Server",
      autoComplete: true
    }), React.createElement(Form.Fields.Number, {
      placeholder: "587",
      required: true,
      name: "SMTPPort",
      label: "Port",
      autoComplete: {
        list: 'SMTPPortList',
        values: [25, 587]
      }
    }), React.createElement(Form.Fields.Name, {
      placeholder: "notification@email.com",
      required: true,
      name: "SMTPUsername",
      label: "Username",
      autoComplete: true
    }), React.createElement(Form.Fields.Password, {
      required: true,
      name: "SMTPPassword",
      label: "Password",
      autoComplete: true
    }), React.createElement(Form.Fields.Checkbox, {
      name: "SMTPSSL",
      label: "Encrypt",
      autoComplete: true
    }));
  }

  function renderAWSEMailConnection(queue, initialQueue) {
    return React.createElement(React.Fragment, null, React.createElement(Form.Fields.RadioGroup, {
      name: "AWSType",
      label: "",
      row: true,
      options: awsTypes
    }), React.createElement(Form.Condition, {
      when: "AWSType",
      is: "Email"
    }, renderAWSEmail(), initialQueue != undefined ? initialQueue.AWSEmail != null && initialQueue.AWSEmail == queue.AWSEmail ? renderAWSEmailStatus(queue) : null : null), React.createElement(Form.Condition, {
      when: "AWSType",
      is: "Domain"
    }, renderAWSDomain(), initialQueue != undefined ? initialQueue.AWSDomain != null && initialQueue.AWSDomain == queue.AWSDomain ? renderAWSDomainStatus(queue) : null : null));
  }

  function renderAWSEmail() {
    return React.createElement(React.Fragment, null, React.createElement(Grid, {
      container: true,
      direction: "row",
      justify: "center",
      alignItems: "center"
    }, React.createElement(Grid, {
      item: true,
      xs: 12,
      md: 12,
      sm: 12,
      lg: 12
    }, React.createElement(Grid, {
      container: true,
      direction: "row",
      justify: "center",
      alignItems: "center"
    }, React.createElement(Grid, {
      item: true,
      xs: 4,
      md: 4,
      sm: 4,
      lg: 4
    }, React.createElement(FormLabel, {
      htmlFor: "AWSDomain"
    }, "Email")), React.createElement(Grid, {
      item: true,
      xs: 8,
      md: 8,
      sm: 8,
      lg: 8
    }, React.createElement(Form.Fields.Email, {
      placeholder: "notification@email.com",
      required: true,
      name: "AWSEmail",
      label: null,
      autoComplete: true
    }))))));
  }

  function renderAWSEmailStatus(queue) {
    return React.createElement(React.Fragment, null, React.createElement(Grid, {
      container: true,
      direction: "row",
      justify: "center",
      alignItems: "center"
    }, React.createElement(Grid, {
      item: true,
      xs: 4
    }, React.createElement(Typography, null, "Verification Status")), React.createElement(Grid, {
      item: true,
      xs: 2
    }, React.createElement(Form.Condition, {
      when: "Status",
      is: "Success"
    }, React.createElement(Grid, {
      item: true
    }, React.createElement(Typography, null, " Success"))), React.createElement(Form.Condition, {
      when: "Status",
      is: "Pending"
    }, React.createElement(Grid, {
      item: true
    }, React.createElement(Typography, {
      color: "secondary"
    }, " Pending"))), React.createElement(Form.Condition, {
      when: "Status",
      is: "Failed"
    }, React.createElement(Grid, {
      item: true
    }, React.createElement(Typography, {
      color: "error"
    }, " Failed")))), React.createElement(Grid, {
      item: true,
      xs: 6
    }, queue.Status != 'Success' ? React.createElement(React.Fragment, null, React.createElement(Button, {
      variant: "text",
      onClick: function onClick() {
        resendAWSEmail();
      }
    }, "Resend Email")) : null)));
  }

  function renderAWSDomainStatus(queue) {
    return React.createElement(React.Fragment, null, React.createElement(Grid, {
      container: true,
      direction: "row",
      justify: "center",
      alignItems: "center"
    }, React.createElement(Grid, {
      item: true,
      xs: 4
    }, React.createElement(Typography, null, "Status")), React.createElement(Grid, {
      item: true,
      xs: 2
    }, React.createElement(Form.Condition, {
      when: "Status",
      is: "Success"
    }, React.createElement(Grid, {
      item: true
    }, React.createElement(Typography, null, " Success"))), React.createElement(Form.Condition, {
      when: "Status",
      is: "Pending"
    }, React.createElement(Grid, {
      item: true
    }, React.createElement(Typography, {
      color: "secondary"
    }, " Pending"))), React.createElement(Form.Condition, {
      when: "Status",
      is: "Failed"
    }, React.createElement(Grid, {
      item: true
    }, React.createElement(Typography, {
      color: "error"
    }, " Failed")))), React.createElement(Grid, {
      item: true,
      xs: 6
    }, queue.Status != 'Success' ? React.createElement(React.Fragment, null, React.createElement(Button, {
      variant: "text",
      onClick: function onClick() {
        verifyAWSConnection(queue.Name);
      }
    }, "View Amazon Settings")) : null)));
  }

  function renderAWSDomain() {
    return React.createElement(React.Fragment, null, React.createElement(Grid, {
      container: true,
      direction: "row",
      justify: "center",
      alignItems: "center"
    }, React.createElement(Grid, {
      item: true,
      xs: 12,
      md: 12,
      sm: 12,
      lg: 12
    }, React.createElement(Grid, {
      container: true,
      direction: "row",
      justify: "center",
      alignItems: "center"
    }, React.createElement(Grid, {
      item: true,
      xs: 4,
      md: 4,
      sm: 4,
      lg: 4
    }, React.createElement(FormLabel, {
      htmlFor: "AWSDomain"
    }, "Domain")), React.createElement(Grid, {
      item: true,
      xs: 8,
      md: 8,
      sm: 8,
      lg: 8
    }, React.createElement(Form.Fields.Domain, {
      placeholder: "smtp.email.com",
      required: true,
      name: "AWSDomain",
      label: null,
      fullWidth: true,
      autoComplete: true
    }))))));
  }

  var emailConnectionDataItemProps = {
    dataType: 'emailConnection',
    id: queue
  };
  return React.createElement(React.Fragment, null, React.createElement(Typography, {
    variant: "h6"
  }, "Configure Email"), React.createElement(DataItem, emailConnectionDataItemProps, function (_ref2) {
    var orginalQueue = _ref2.value;
    return React.createElement(Form.Fragment, {
      variant: "filled",
      dataItemProps: emailConnectionDataItemProps,
      defaultValue: {
        SMTPPort: 587,
        SMTPSSL: true,
        Type: 'smtp',
        RadioGroup: 'aws'
      },
      submitAlign: "left",
      onSuccess: function onSuccess(data, payload) {
        setEmailConnection({
          status: {
            error: null,
            success: 'Connection saved'
          }
        });
        data.Type == 'AWS' ? Modal.open({
          type: Modal.TYPES.VERIFY_EMAIL_SETTINGS,
          props: {
            AWSEmail: data.AWSEmail,
            AWSDomain: data.AWSDomain,
            Token: payload.ValidationToken,
            AWSType: data.AWSType
          }
        }) : null;
      },
      renderFooterLeft: function renderFooterLeft(_ref3) {
        var invalid = _ref3.invalid,
            values = _ref3.values;
        return React.createElement(Button, {
          onClick: function onClick() {
            return Modal.open({
              type: Modal.TYPES.TEST_EMAIL_SETTINGS,
              props: {
                connection: values
              }
            });
          }
        }, "Test");
      },
      renderContent: function renderContent(_ref4) {
        var values = _ref4.values;
        return React.createElement(Grid, {
          container: true,
          direction: "row",
          spacing: 6
        }, React.createElement(Grid, {
          item: true,
          xs: true,
          lg: 4
        }, emailConnection.status.error && React.createElement(Form.Error, null, emailConnection.status.error), React.createElement(Form.Fields.MultiSelect, {
          required: true,
          name: "Type",
          id: "Type",
          label: null,
          variant: "filled",
          options: emailTypes,
          searchable: false,
          margin: "none"
        }), React.createElement(Form.Condition, {
          when: "Type",
          is: "SMTP"
        }, renderSMTPEMailConnection()), React.createElement(Form.Condition, {
          when: "Type",
          is: "AWS"
        }, renderAWSEMailConnection(values, orginalQueue))), React.createElement(Grid, {
          item: true,
          xs: true
        }, React.createElement(Form.Fields.Checkbox, {
          name: "Track",
          label: "Track email read, clicks and other engagement activities"
        }), React.createElement(Grid, {
          container: true,
          direction: "row",
          alignItems: "center"
        }, React.createElement(Grid, {
          item: true,
          xs: true
        }, React.createElement(Form.Fields.Checkbox, {
          name: "SuspendBounce",
          label: "Suspend bounced email addresses"
        })), React.createElement(Grid, {
          item: true
        }, React.createElement(Button, {
          disabled: !values.SuspendBounce,
          onClick: function onClick() {
            return history.push('/settings/email/bounced');
          }
        }, "Bounced Emails")))));
      }
    });
  }));
};

Queue.defaultProps = {
  queue: 'Default'
};
export default Queue;